import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/c30_logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2c0bcfa2")

_pushScopeId("data-v-2c0bcfa2")
const _hoisted_1 = { class: "dt-open-api-header-box" }
const _hoisted_2 = { class: "dt-open-api-header-left" }
const _hoisted_3 = { class: "dt-open-api-header-logo" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "开放平台", -1)
const _hoisted_6 = { class: "dt-open-api-header-nav" }
const _hoisted_7 = { class: "dt-open-api-header-right" }
const _hoisted_8 = {
  key: 0,
  class: "dt-open-api-header-right-link"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "登录", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "dt-open-api-header-right-split" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "注册", -1)
const _hoisted_13 = {
  key: 1,
  class: "dt-open-api-header-right-link"
}
const _hoisted_14 = { class: "el-dropdown-link" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("企业信息")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "确认退出吗？", -1)
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_login_modal = _resolveComponent("login-modal")
  const _component_edit_password_modal = _resolveComponent("edit-password-modal")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("div", _hoisted_3, [
          _hoisted_4
        ], 512), [
          [_vShow, !_ctx.isJLWX]
        ]),
        _hoisted_5
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("ul", null, [
          _withDirectives(_createVNode("li", {
            class: ["click-element", _ctx.headerMenuIndex === _ctx.HEADER_MENU.HOME ? 'app-active':''],
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.changeMenuIndex(_ctx.HEADER_MENU.HOME)))
          }, "首页 ", 2), [
            [_vShow, !_ctx.isJLWX]
          ]),
          _createVNode("li", {
            class: ["click-element", _ctx.headerMenuIndex === _ctx.HEADER_MENU.API ? 'app-active':''],
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.changeMenuIndex(_ctx.HEADER_MENU.API)))
          }, "文档 ", 2),
          (_ctx.userId)
            ? (_openBlock(), _createBlock("li", {
                key: 0,
                class: ["click-element", _ctx.headerMenuIndex === _ctx.HEADER_MENU.PERSONAL ? 'app-active':''],
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.changeMenuIndex(_ctx.HEADER_MENU.PERSONAL)))
              }, "个人中心 ", 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        (!_ctx.userId)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("div", {
                class: "dt-open-api-header-right-login click-element",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.gotoLogin(...args)))
              }, [
                _hoisted_9,
                _hoisted_10
              ]),
              _hoisted_11,
              _createVNode("div", {
                class: "dt-open-api-header-right-login click-element",
                onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.gotoRegister(...args)))
              }, [
                _hoisted_12
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_el_dropdown, { trigger: "click" }, {
                dropdown: _withId(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withId(() => [
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.gotoEditFactoryInfo }, {
                        default: _withId(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.gotoResetPassword }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.wantLogout }, {
                        default: _withId(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withId(() => [
                  _createVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.enterpriseFullName.length > 10 ? _ctx.enterpriseFullName.substring(0,10)+'...':_ctx.enterpriseFullName), 1 /* TEXT */),
                    _hoisted_15
                  ])
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createVNode(_component_login_modal, {
      dialogVisible: _ctx.visibleModal,
      onCloseModal: _ctx.closeModal
    }, null, 8, ["dialogVisible", "onCloseModal"]),
    _createVNode(_component_edit_password_modal, {
      dialogVisible: _ctx.editPasswordVisibleModal,
      onCloseModal: _ctx.closeEditPasswordModal
    }, null, 8, ["dialogVisible", "onCloseModal"]),
    _createVNode(_component_el_dialog, {
      title: "提示",
      modelValue: _ctx.logoutDialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.logoutDialogVisible = $event)),
      width: "30%",
      "close-on-click-modal": _ctx.clickModalClose,
      "before-close": _ctx.handleClose
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = $event => (_ctx.logoutDialogVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.logout
          }, {
            default: _withId(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _hoisted_19
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal", "before-close"])
  ], 64 /* STABLE_FRAGMENT */))
})